module.exports = __webpack_public_path__ + "static/shopify_6-c43be12146959c5efd3b4a29c75bc566.png";